import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { createTypeUtils } from '../type-filter/TypeFilterHelper';

export const SWITCH = 'switch';
export const ROUTER = 'router';
export const FIREWALL = 'firewall';
export const SERVER = 'server';
export const GENERIC = 'generic';
export const WIRELESS_CONTROLLER = 'wirelesscontroller';
export const ACCESSPOINT = 'accesspoint';
export const NPOINT = 'npoint';
export const IDRAC = 'idrac';
export const IOT = 'iot';
export const PRINTER = 'printer';
export const PACKET_PROCESSOR = 'packet-processor';
export const UPS_PSU = 'ups-psu';
export const KVM = 'kvm';
export const NAS = 'nas';
export const RAID_MANAGEMENT = 'raid-management';
export const NEW = 'new';
export const DEFAULT = '_default';

export const DEVICE_TYPE_NAMES = {
    [NEW]: i18n._(t`Unknown`),
    [ACCESSPOINT]: i18n._(t`Access Point`),
    [FIREWALL]: i18n._(t`Firewall`),
    [GENERIC]: i18n._(t`Generic`),
    [IDRAC]: i18n._(t`iDrac`),
    [IOT]: i18n._(t`IOT`),
    [KVM]: i18n._(t`KVM`),
    [NAS]: i18n._(t`NAS`),
    [NPOINT]: i18n._(t`nPoint`),
    [PACKET_PROCESSOR]: i18n._(t`Packet Processor`),
    [PRINTER]: i18n._(t`Printer`),
    [RAID_MANAGEMENT]: i18n._(t`RAID Management`),
    [ROUTER]: i18n._(t`Router`),
    [SERVER]: i18n._(t`Server`),
    [SWITCH]: i18n._(t`Switch`),
    [UPS_PSU]: i18n._(t`UPS/PSU`),
    [WIRELESS_CONTROLLER]: i18n._(t`Wireless Controller`),
};

export const {
    objects: DEVICE_TYPE_OBJECTS,
    values: DEVICE_TYPE_VALUES,
    getName: getDeviceTypeName,
} = createTypeUtils(DEVICE_TYPE_NAMES);
